/**
 * @file logger.ts
 * @description Simple logging toggle for E2E test output. Set
 * `Logger.isLoggingEnabled = true` to enable trace-level log messages.
 */

// External libraries

// Local libraries

export class Logger {
  static isLoggingEnabled = false;

  static log(message: string): void {
    if (this.isLoggingEnabled) {
      console.log(message);
    }
  }
}
